import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { actions as formActions } from 'react-redux-form';
import { InvestmentFactors } from './InvestmentFactors';
import RASuitabilityTest from 'actions/RASuitabilityTest';
import RASuitabilityTestWizardActions from 'actions/RASuitabilityTestWizardActions';
import modalCancelActions from 'actions/modalCancelActions';

export const InvestmentFactorsContainer = connect(
    state => ({
        userProfile: state.userProfile,
        RATestWizard: state.raSuitabilityTestWizard,
        immSuitabilityTest: state.raSuitabilityTest,
    }),
    dispatch => ({
        raTestActions: bindActionCreators(RASuitabilityTestWizardActions, dispatch),
        raSuitabilityTest: bindActionCreators(RASuitabilityTest, dispatch),
        formActions: bindActionCreators(formActions, dispatch),
        modalCancelActions: bindActionCreators(modalCancelActions, dispatch),
    })
)(InvestmentFactors);
